export default __webpack_public_path__ + "static/media/twitter.fb501218.png";